<template>
  <!-- Keep this as a local fallback in case the embedded widget can't initialize -->
  <div v-if="isLocalhost && !embeddedWidgetReady" class="support-chat-launcher">
    <v-btn
      class="support-chat-btn"
      color="#592892"
      elevation="8"
      icon
      @click="open"
      :aria-label="$t('navbar.supportChat')"
      :title="$t('navbar.supportChat')"
    >
      <v-icon icon="chat" color="white" />
    </v-btn>
  </div>
</template>

<script>
  import { openLiveHelperChat } from '@/services/LiveHelperChatService'

  export default {
    name: 'SupportChatLauncher',
    data() {
      return {
        embeddedWidgetReady: false,
      }
    },
    computed: {
      supportChatConfig() {
        return this.$store.getters['AppData/getSupportChatConfig'] || {}
      },
      isLocalhost() {
        const origin = typeof window !== 'undefined' ? window.location.origin : ''
        return origin.includes('localhost') || origin.includes('127.0.0.1')
      },
    },
    mounted() {
      if (!this.isLocalhost) return
      // Poll briefly: once the embedded widget iframe exists, hide this fallback button.
      let tries = 0
      const maxTries = 30 // ~6s
      const tick = () => {
        tries++
        try {
          const hasIframe = !!document.querySelector('#lhc_status_container_page iframe')
          const hasScript = !!document.getElementById('lhc_widgetv2_script')
          if (hasIframe || hasScript) {
            this.embeddedWidgetReady = true
            return
          }
        } catch (e) {
          // ignore
        }
        if (tries < maxTries) setTimeout(tick, 200)
      }
      tick()
    },
    methods: {
      open() {
        openLiveHelperChat(this.supportChatConfig.lhc || {})
      },
    },
  }
</script>

<style scoped>
  .support-chat-launcher {
    position: fixed;
    right: 18px;
    bottom: 38px;
    z-index: 2147483000; /* above Vuetify overlays */
  }

  @media print {
    .support-chat-launcher {
      display: none !important;
    }
  }
</style>


